import { Controller } from "@hotwired/stimulus";

// Add/remove rows for an accepts_nested_attributes_for collection (timeline entries,
// field sources). The "Add" button clones a <template> whose NEW_RECORD placeholder is
// swapped for a unique index; "Remove" either drops a not-yet-saved row outright or
// hides a persisted one and flips its hidden _destroy flag so Rails deletes it on save.
export default class extends Controller {
  static targets = ["rows", "template", "position"];

  add(event) {
    event.preventDefault();
    const index = new Date().getTime();
    const template = document.createElement("template");
    template.innerHTML = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, index);
    const positionField = template.content.querySelector('[data-nested-form-target~="position"]');
    if (positionField) positionField.value = this.nextPosition();
    this.rowsTarget.append(template.content);
  }

  nextPosition() {
    const positions = this.positionTargets
      .filter((field) => {
        const row = field.closest("[data-nested-form-row]");
        return row.querySelector("input[name$='[_destroy]']")?.value !== "1";
      })
      .map((field) => field.valueAsNumber)
      .filter(Number.isFinite);

    return positions.length ? Math.max(...positions) + 1 : 0;
  }

  remove(event) {
    event.preventDefault();
    const row = event.target.closest("[data-nested-form-row]");
    if (!row) return;

    const idField = row.querySelector("input[name*='[id]']");
    const destroyField = row.querySelector("input[name*='_destroy']");
    if (idField && idField.value && destroyField) {
      destroyField.value = "1";
      row.classList.add("hidden");
    } else {
      row.remove();
    }
  }
}
